import { render, staticRenderFns } from "./Propagandas.vue?vue&type=template&id=54b7678c"
import script from "./Propagandas.vue?vue&type=script&lang=js"
export * from "./Propagandas.vue?vue&type=script&lang=js"
import style0 from "./Propagandas.vue?vue&type=style&index=0&id=54b7678c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports